module.exports = __webpack_public_path__ + "static/media/left_chevron.9a02b6cf.svg";